
import {
	defineComponent,
	defineAsyncComponent,
	onMounted,
	ref,
	watch,
} from 'vue';

export default defineComponent({
	props: {
		icon: {
			default: null,
		},
		items: {
			required: true,
			type: Object,
		},
		show: {
			required: true,
			type: Boolean,
		},
	},
	setup(props, { emit }) {
		const subNav = ref(null);

		onMounted(() => (subNav.value as any).classList.add('h-0', 'py-0'));

		const getIcon = (icon: string) => {
			return defineAsyncComponent({
				loader: () =>
					import(`@/components/ui-elements/icons/${icon}.vue`),
			});
		};

		const handleClick = (value: string) => {
			emit('nav-clicked', value);
		};

		watch(
			() => props.show,
			n => {
				if (!n) {
					setTimeout(
						() =>
							(subNav.value as any).classList.add('h-0', 'py-0'),
						400
					);
				} else {
					(subNav.value as any).classList.remove('h-auto', 'py-1');
				}
			}
		);

		return { getIcon, handleClick, subNav };
	},
});
